import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button, Input, Row, Col } from "reactstrap";
import { deleteQuestionOptions } from "../../../slices/thunks";


const AddQuestionOptionForm = ({ labels, isAddOrEdit, selectedRow, setSelectedRow, onChangeHandler }) => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [focused, setFocused] = useState({});

    const onhandleFocus = (e) => {
        const id = e.target.id;
        setFocused((prevFocused) => ({ ...prevFocused, [id]: true }));
    }

    const handleOptionChange = (e, index) => {
        const { name, value } = e.target;
        const updatedOptions = selectedRow.Options?.map((option, i) => {
            if (index === i) {
                return { ...option, [name]: value };
            }
            return option; 
        })
        setSelectedRow((prev) => ({
            ...prev,
            Options: updatedOptions
        }));
    };

    const handleCorrectAnswer = (e, index) => {
        const { name, checked } = e.target;
        const updatedOptions = selectedRow.Options?.map((option, i) => {
            if (index === i) {
                return { ...option, [name]: checked.toString() };
            } else {
                return { ...option, [name]: "false" };
            }
        })
        setSelectedRow((prev) => ({
            ...prev,
            Options: updatedOptions
        }));
    }
    
    const handleAddOption = () => {
        if (selectedRow.Options.length < 5) {
            setSelectedRow({...selectedRow, Options: [...selectedRow.Options, { OptionEn: "", OptionAr: "", IsCorrect: false }]});
        } else {
            // Optionally, inform the user they've reached the limit, e.g., using a toast notification or alert.
            console.warn("Maximum of 5 options allowed.");
        }
    };
    
    const handleRemoveOption = (index) => {
        const option = selectedRow.Options[index];
        const updatedOptions = selectedRow.Options.filter((_, i) => i !== index);
        setSelectedRow({...selectedRow, Options: updatedOptions});
        if (option.ID) {
            dispatch(deleteQuestionOptions({Ids: [option.ID]}))
        }
    };

    const canAddMoreOptions = selectedRow.Options?.length < 5;

    return (
        <Row>
            { labels?.map((items) => {
                switch (items?.fieldName || items?.labelName) {
                    case 'text-box':
                        return (
                            <Col key={items?.id} sm={12}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        name={items?.name}
                                        defaultValue={i18n.language === 'en' ? selectedRow['QuestionTitleEn'] : selectedRow['QuestionTitleAr']}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        disabled
                                     />
                                </div>
                            </Col>
                        );

                    case 'option-box': 
                        return (
                            <Col key={items.id} sm={12}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}</label>
                                    {selectedRow[items.name]?.map((opt, index) => (
                                        <Row key={index} className="align-items-center mb-2">
                                            <Col xs="1">
                                            <Input
                                                type="radio"
                                                name="IsCorrect"
                                                checked={opt.IsCorrect?.toString() == "true"}
                                                onChange={(e) => handleCorrectAnswer(e, index)}
                                            />
                                            </Col>
                                            <Col xs="5">
                                            <Input
                                                rows="2"
                                                type="textarea"
                                                className="form-control"
                                                placeholder={t("Option English", { letter: String.fromCharCode(65 + index) })}
                                                defaultValue={opt['OptionEn']}
                                                name="OptionEn"
                                                onChange={(e) => handleOptionChange(e, index)}
                                                id={`OptionEn${index}`}
                                                onBlur={onhandleFocus}
                                                focused={focused[`OptionEn${index}`] && focused[`OptionEn${index}`].toString()}
                                                required 
                                            />
                                            </Col>
                                            <Col xs="5">
                                            <Input
                                                rows="2"
                                                type="textarea"
                                                className="form-control"
                                                placeholder={t("Option Arabic", { letter: String.fromCharCode(65 + index) })}
                                                defaultValue={opt['OptionAr']}
                                                name="OptionAr"
                                                onChange={(e) => handleOptionChange(e, index)}
                                                id={`OptionAr${index}`}
                                                onBlur={onhandleFocus}
                                                focused={focused[`OptionAr${index}`] && focused[`OptionAr${index}`].toString()}
                                                required 
                                            />
                                            </Col>
                                            <Col className="d-flex justify-content-center" xs="1">
                                            {index > 1 && (
                                                <Button color="link" onClick={() => handleRemoveOption(index)}>
                                                    <i className="ri-delete-bin-7-line align-bottom"></i>
                                                </Button>
                                            )}
                                            </Col>
                                        </Row>
                                    ))}
                                    {canAddMoreOptions && (
                                    <Button color="link" onClick={handleAddOption} className="mt-2" disabled={!canAddMoreOptions}>
                                        <i className="ri-add-circle-line align-bottom me-2 ms-2"></i>
                                        {t('Add Option')}
                                    </Button>
                                    )}
                                </div>
                            </Col>
                        )

                    default:
                        return null
                }
            })}
        </Row>
    )
}

export default AddQuestionOptionForm